/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class AddressMasterDialog extends Common.GridEditorDialog<AddressMasterRow> {
        protected getFormKey() { return AddressMasterForm.formKey; }
        //protected getIdProperty() { return AddressMasterRow.idProperty; }
        protected getLocalTextPrefix() { return AddressMasterRow.localTextPrefix; }
        protected getNameProperty() { return AddressMasterRow.nameProperty; }
        //protected getService() { return AddressMasterService.baseUrl; }
        //protected getInsertPermission() { return AddressMasterRow.insertPermission; }
        //protected getUpdatePermission() { return AddressMasterRow.updatePermission; }
        //protected getDeletePermission() { return AddressMasterRow.deletePermission; }
        //protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions) }
        protected useViewMode() { return true; }

        protected form = new AddressMasterForm(this.idPrefix);
        constructor() {
            super();
            this.form.Country.changeSelect2(e => {
                this.form.CountryName.value = CountriesMasterRow.getLookup().itemById[this.form.Country.value].Name;
                Q.reloadLookup(StatesMasterRow.lookupKey);
                this.form.State.cascadeField = "CountryId";
                this.form.State.cascadeValue = this.form.Country.value;
            });
            this.form.State.changeSelect2(e => {
                this.form.StateName.value = StatesMasterRow.getLookup().itemById[this.form.State.value].StateName;
                Q.reloadLookup(CitiesMasterRow.lookupKey);
                this.form.City.cascadeField = "StateId";
                this.form.City.cascadeValue = this.form.State.value;
            });
            this.form.City.changeSelect2(e => {
                this.form.CityName.value = CitiesMasterRow.getLookup().itemById[this.form.City.value].Name;
            });
        }


    }
}
